module.exports = __webpack_public_path__ + "img/screenshot2-phone.d413b097.jpg";